<template>
    <!-- Modo Normal -->
    <div v-if="!isKioskMode" 
      class="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 p-4 transition-all duration-300">
      
      <!-- Header com controles -->
      <div class="mb-6">
        <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6">
          <h1 class="text-3xl font-bold text-gray-900 dark:text-white">Calendário de Folgas e Plantões</h1>
          
          <div class="flex gap-3 sm:ml-auto">
            <button @click="abrirModoTV" 
              class="px-4 py-2 rounded-lg border font-medium transition-all flex items-center gap-2 bg-blue-600 text-white border-blue-600 hover:bg-blue-700">
              <Monitor class="h-4 w-4" />
              Modo TV
            </button>
            <button @click="refreshData" :disabled="isLoading"
              class="px-4 py-2 rounded-lg border font-medium transition-all flex items-center gap-2 bg-green-600 text-white border-green-600 hover:bg-green-700 disabled:opacity-50">
              <RefreshCw :class="['h-4 w-4', isLoading ? 'animate-spin' : '']" />
              Atualizar
            </button>
          </div>
        </div>
      </div>
  
      <!-- Cards de resumo -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-md border border-gray-100 dark:border-gray-700 p-5 transition-all duration-200">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Folgas Hoje</p>
              <p class="text-2xl font-bold text-blue-600 dark:text-blue-400">{{ folgasHoje.length }}</p>
            </div>
            <div class="h-14 w-14 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center">
              <Calendar class="h-7 w-7 text-blue-600 dark:text-blue-400" />
            </div>
          </div>
        </div>
        
        <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-md border border-gray-100 dark:border-gray-700 p-5 transition-all duration-200">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Esta Semana</p>
              <p class="text-2xl font-bold text-green-600 dark:text-green-400">{{ folgasEstaSemana.length }}</p>
            </div>
            <div class="h-14 w-14 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center">
              <Users class="h-7 w-7 text-green-600 dark:text-green-400" />
            </div>
          </div>
        </div>
  
        <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-md border border-gray-100 dark:border-gray-700 p-5 transition-all duration-200">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Pendentes</p>
              <p class="text-2xl font-bold text-yellow-600 dark:text-yellow-400">{{ folgasPendentes.length }}</p>
            </div>
            <div class="h-14 w-14 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center">
              <Clock class="h-7 w-7 text-yellow-600 dark:text-yellow-400" />
            </div>
          </div>
        </div>
  
        <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-md border border-gray-100 dark:border-gray-700 p-5 transition-all duration-200">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Última Atualização</p>
              <p class="text-lg font-bold text-gray-900 dark:text-white">{{ formatTime(lastUpdate) }}</p>
            </div>
            <div class="h-14 w-14 bg-purple-100 dark:bg-purple-900/30 rounded-full flex items-center justify-center">
              <RefreshCw class="h-7 w-7 text-purple-600 dark:text-purple-400" />
            </div>
          </div>
        </div>
      </div>
  
      <!-- Calendário Normal -->
      <div class="w-full">
        <div class="flex justify-between items-center mb-6">
          <button @click="prevMonth" class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
            <ChevronLeft class="w-6 h-6 text-gray-700 dark:text-gray-300" />
          </button>
          <h3 class="text-2xl font-bold text-gray-800 dark:text-white">{{ currentMonthName }} {{ currentYear }}</h3>
          <button @click="nextMonth" class="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
            <ChevronRight class="w-6 h-6 text-gray-700 dark:text-gray-300" />
          </button>
        </div>
  
        <!-- Grade do calendário -->
        <div class="grid grid-cols-7 gap-2 w-full">
          <div v-for="day in ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']" :key="day"
            class="text-center p-3 text-sm font-medium text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-700 rounded-lg">
            {{ day }}
          </div>
  
          <div v-for="(day, index) in calendarDays" :key="index"
            class="min-h-[120px] p-2 rounded-lg border transition-all hover:shadow-md cursor-pointer bg-transparent"
            :class="getDayClasses(day)"
            @click="showDayDetails(day)">
            
            <div class="flex flex-col h-full">
              <span class="text-sm font-medium mb-2" :class="day.isCurrentMonth ? 'text-gray-700 dark:text-gray-300' : 'text-gray-400'">
                {{ day.day }}
              </span>
              
<div class="flex-1 space-y-1 overflow-y-auto">
  
  <div v-for="plantao in getPlantoesForDay(day.date)" :key="`plantao-${plantao.id}`"
  class="text-xs px-2 py-1 rounded truncate font-medium flex items-center gap-1 bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
  title="Plantão">
    <ShieldUser class="h-3 w-3" />
    <span v-for="(membro, index) in plantao.members" :key="membro.id">
      {{ membro.user_name.split(' ')[0] }}{{ index < plantao.members.length - 1 ? ', ' : '' }}
    </span>
  </div>
  
  <div v-for="swap in getOnCallSwapRequestsForDay(day.date)" :key="swap.id"
    class="text-xs px-2 py-1 rounded truncate font-medium flex items-center gap-1 bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200"
    title="Troca Solicitada">
    <RefreshCwIcon class="h-3 w-3" />
    {{ swap.user_name.split(' ')[0] }}
  </div>
  
  <div v-for="folga in getFolgasForDay(day.date)" :key="folga.id"
    class="text-xs px-2 py-1 rounded truncate font-medium"
    :class="getFolgaStatusClass(folga.status)">
    {{ folga.user_name.split(' ')[0] }}
  </div>

</div>
            </div>
          </div>
        </div>
  
        <!-- Legenda -->
          <div class="mt-6 flex flex-wrap gap-4 justify-center">
            <div class="flex items-center gap-2">
              <div class="w-4 h-4 rounded bg-green-100 dark:bg-green-900"></div>
              <span class="text-sm text-gray-700 dark:text-gray-300">Aprovadas</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-4 h-4 rounded bg-yellow-100 dark:bg-yellow-900"></div>
              <span class="text-sm text-gray-700 dark:text-gray-300">Pendentes</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-4 h-4 rounded bg-red-100 dark:bg-red-900"></div>
              <span class="text-sm text-gray-700 dark:text-gray-300">Rejeitadas</span>
            </div>
            <div class="flex items-center gap-2">
              <ShieldUser class="h-4 w-4 text-blue-600" />
              <span class="text-sm text-gray-700 dark:text-gray-300">Plantão</span>
            </div>
            <div class="flex items-center gap-2">
              <RefreshCwIcon class="h-4 w-4 text-yellow-600" />
              <span class="text-sm text-gray-700 dark:text-gray-300">Troca Solicitada</span>
            </div>
          </div>
      </div>
    </div>
  
    <!-- Modo Kiosk/TV -->
    <div v-else class="fixed inset-0 z-[9999] flex h-screen w-screen flex-col overflow-auto bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white transition-all duration-300 [text-shadow:0_2px_4px_rgba(0,0,0,0.5)]">
      <!-- Header do modo TV -->
      <div class="bg-black/30 backdrop-blur-sm border-b border-white/10 p-8">
        <div class="flex justify-between items-center">
          <!-- Logo -->
          <div class="flex items-center">
            <div class="w-16 h-16 bg-blue-500/20 border border-blue-400/30 rounded-full flex items-center justify-center">
              <Calendar class="h-8 w-8 text-blue-400" />
            </div>
          </div>
          
          <!-- Título centralizado -->
          <div class="flex-1 flex justify-center">
            <h1 class="text-5xl font-bold bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
              Calendário de Folgas e Plantões
            </h1>
          </div>
          
          <!-- Status e informações -->
          <div class="flex items-center gap-6">
            <!-- Última atualização -->
            <div class="bg-black/30 backdrop-blur-sm border border-white/10 rounded-xl p-4">
              <div class="flex items-center gap-3">
                <div class="h-12 w-12 bg-purple-500/20 border border-purple-400/30 rounded-full flex items-center justify-center">
                  <RefreshCw class="h-6 w-6 text-purple-400" />
                </div>
                <div>
                  <p class="text-xs font-medium text-gray-300">Última Atualização</p>
                  <p class="text-lg font-bold text-white">{{ formatTime(lastUpdate) }}</p>
                  <p class="text-xs font-medium text-purple-300">Atualização automática às 00h</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Calendário TV -->
      <div class="p-8">
        <div class="bg-black/30 backdrop-blur-sm border border-white/10 rounded-3xl p-8">
          <!-- Header do calendário -->
          <div class="flex justify-between items-center mb-8">
            <button @click="prevMonth" class="p-4 rounded-full bg-white/10 hover:bg-white/20 transition-colors">
              <ChevronLeft class="w-8 h-8 text-white" />
            </button>
            <h2 class="text-4xl font-bold text-white">{{ currentMonthName }} {{ currentYear }}</h2>
            <button @click="nextMonth" class="p-4 rounded-full bg-white/10 hover:bg-white/20 transition-colors">
              <ChevronRight class="w-8 h-8 text-white" />
            </button>
          </div>
  
          <!-- Grade do calendário TV -->
          <div class="grid grid-cols-7 gap-4">
            <div v-for="day in ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']" :key="day"
              class="text-center p-4 text-xl font-bold text-blue-300 bg-blue-500/20 border border-blue-400/30 rounded-xl">
              {{ day }}
            </div>
  
            <div v-for="(day, index) in calendarDays" :key="index"
              class="min-h-[160px] p-4 rounded-xl border transition-all"
              :class="getTVDayClasses(day)">
              
              <div class="flex flex-col h-full">
                <div class="flex justify-between items-center mb-3">
                  <span class="text-2xl font-bold" :class="day.isCurrentMonth ? 'text-white' : 'text-gray-500'">
                    {{ day.day }}
                  </span>
                  <div v-if="getFolgasForDay(day.date).length > 0" 
                    class="bg-green-500/40 border border-green-400/60 rounded-full px-3 py-1">
                    <span class="text-sm font-bold text-green-100">{{ getFolgasForDay(day.date).length }}</span>
                  </div>
                </div>
                
                <div class="flex-1 space-y-2 overflow-y-auto">
                  <!-- Plantões -->
                  <div v-for="duty in getOnCallDutiesForDay(day.date).slice(0, 2)" :key="duty.id">
                    <div v-for="member in getOnCallDutyMembers(duty)" :key="member.user_name"
                      class="text-sm px-3 py-2 rounded-lg font-bold border bg-red-500/40 border-red-400/60 text-red-100 flex items-center gap-2"
                      :title="`Plantão - ${member.role === 'primary' ? 'Principal' : 'Secundário'}`">
                      <ShieldUser class="h-4 w-4" />
                      {{ member.user_name }}
                    </div>
                  </div>
                  
                  <!-- Trocas Solicitadas -->
                  <div v-for="swap in getOnCallSwapRequestsForDay(day.date).slice(0, 2)" :key="swap.id"
                    class="text-sm px-3 py-2 rounded-lg font-bold border bg-yellow-500/30 border-yellow-400/50 text-yellow-200 flex items-center gap-2"
                    title="Troca Solicitada">
                    <RefreshCwIcon class="h-4 w-4" />
                    {{ swap.user_name }}
                  </div>
                  
                  <!-- Folgas -->
                  <div v-for="folga in getFolgasForDay(day.date).slice(0, 4)" :key="folga.id"
                    class="text-sm px-3 py-2 rounded-lg font-bold border"
                    :class="getTVFolgaStatusClass(folga.status)">
                    {{ folga.user_name }}
                  </div>
                  
                  <!-- Contador de itens adicionais -->
                  <div v-if="getTotalItemsForDay(day.date) > 4"
                    class="text-xs text-center text-gray-300 bg-gray-500/20 rounded-lg py-1">
                    +{{ getTotalItemsForDay(day.date) - 4 }} mais
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Legenda TV -->
          <div class="mt-8 flex justify-center gap-8">
            <div class="flex items-center gap-3">
              <div class="w-6 h-6 rounded bg-green-500/40 border border-green-400/60"></div>
              <span class="text-xl font-bold text-green-300">Folgas Aprovadas</span>
            </div>
            <div class="flex items-center gap-3">
              <div class="w-6 h-6 rounded bg-yellow-500/40 border border-yellow-400/60"></div>
              <span class="text-xl font-bold text-yellow-300">Folgas Pendentes</span>
            </div>
            <div class="flex items-center gap-3">
              <div class="w-6 h-6 rounded bg-red-500/40 border border-red-400/60"></div>
              <span class="text-xl font-bold text-red-300">Plantões</span>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Controles do modo TV -->
      <div class="fixed top-4 right-4">
      </div>
    </div>
  
    <!-- Modal de detalhes do dia -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" @click.self="closeModal">
      <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md">
        <h3 class="text-lg font-semibold mb-4 text-gray-900 dark:text-white">
          Detalhes do dia {{ selectedDay?.day }}/{{ selectedDay?.date ? (selectedDay.date.getMonth() + 1).toString().padStart(2, '0') : '00' }}/{{ selectedDay?.date ? selectedDay.date.getFullYear() : '0000' }}
        </h3>
        
        <div v-if="selectedDayFolgas.length === 0 && selectedDayPlantoes.length === 0" class="text-gray-500 dark:text-gray-400 text-center py-4">
          Nenhum item para este dia.
        </div>
        
        <div v-else class="space-y-3 max-h-60 overflow-y-auto">
          
          <div v-for="duty in selectedDayPlantoes" :key="`modal-duty-${duty.id}`"
            class="p-3 rounded-lg bg-red-100 dark:bg-red-900 border border-red-300 dark:border-red-700">
            <div class="flex items-center justify-between mb-2">
              <div class="text-sm text-red-700 dark:text-red-300 font-medium">Plantão</div>
              <span class="text-xs px-2 py-1 rounded-full font-medium bg-red-200 text-red-800 dark:bg-red-800 dark:text-red-200">
                Plantão
              </span>
            </div>
            <div class="space-y-1">
              <div v-for="member in duty.members" :key="`modal-member-${member.id}`"
                class="font-medium text-red-900 dark:text-red-100 text-sm">
                {{ member.user_name }} 
                <span v-if="member.role === 'primary'" class="text-xs text-red-600 dark:text-red-400"></span>
                <span v-else class="text-xs text-red-600 dark:text-red-400"></span>
              </div>
            </div>
          </div>
          
          <div v-for="folga in selectedDayFolgas" :key="folga.id"
            class="flex items-center justify-between p-3 rounded-lg"
            :class="getFolgaStatusClass(folga.status)">
            <div>
              <div class="font-medium text-gray-800 dark:text-gray-200">{{ folga.user_name }}</div>
              <div class="text-sm text-gray-600 dark:text-gray-400">{{ folga.reason }}</div>
            </div>
<span class="text-xs px-2 py-1 rounded-full font-medium"
      :class="getFolgaStatusClass(folga.status)">  {{ getStatusText(folga.status) }}
</span>
          </div>

        </div>
        
        <div class="flex justify-end mt-6">
          <button @click="closeModal"
            class="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
/* global defineProps, defineEmits */
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import {
  Calendar,
  ChevronLeft,
  ChevronRight,
  Clock,
  Monitor,
  RefreshCw,
  Users,
  ShieldUser,
  RefreshCw as RefreshCwIcon
} from 'lucide-vue-next'
import { useRoute } from 'vue-router'

// 1. DECLARANDO EMITS E PROPS CORRETAMENTE
// O comentário '/* global ... */' no topo do script resolve o erro do linter.
const props = defineProps({
  folgas: {
    type: Array,
    required: true,
  },
  plantoes: {
    type: Array,
    required: true,
  },
  currentDate: {
    type: Date,
    required: true
  }
})
const emit = defineEmits(['update:currentDate', 'refresh'])

// ESTADOS DO COMPONENTE
const route = useRoute()
const isKioskMode = ref(route.query.kiosk === '1')
const isLoading = ref(false)
const lastUpdate = ref(new Date())
const showModal = ref(false)
const selectedDay = ref(null)
const selectedDayFolgas = ref([])
const selectedDayPlantoes = ref([])
const onCallSwapRequests = ref([])

// Estados para modo TV
const tvFolgas = ref([])
const tvPlantoes = ref([])
const tvCurrentDate = ref(new Date()) // Mantido para a função getOnCallSwapRequestsForDay

let autoRefreshTimer = null
let dailyUpdateTimer = null

// Em CalendarioFolgas.vue, dentro do <script setup>

const getStatusText = (status) => {
  const texts = {
    approved: 'Aprovada',
    pending: 'Pendente',
    rejected: 'Rejeitada'
  };
  return texts[status] || status; // Retorna o próprio status se não for encontrado
};
// Em CalendarioFolgas.vue, dentro do <script setup>

const getFolgaStatusClass = (status) => {
  const classes = {
    approved: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    rejected: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
  };
  return classes[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200';
}

const formatTime = (date) => {
  if (!date) return ''; // Garante que não dê erro se a data for nula
  return date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  });
}
// PROPRIEDADES COMPUTADAS
const currentMonthName = computed(() => {
    const currentDate = isKioskMode.value ? tvCurrentDate.value : props.currentDate;
    if (!currentDate) return 'Janeiro'
    const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    return meses[currentDate.getMonth()]
})
  
const currentYear = computed(() => {
    const currentDate = isKioskMode.value ? tvCurrentDate.value : props.currentDate;
    return currentDate ? currentDate.getFullYear() : new Date().getFullYear()
})
  
const calendarDays = computed(() => {
    const currentDate = isKioskMode.value ? tvCurrentDate.value : props.currentDate;
    if (!currentDate) return []
    const year = currentDate.getFullYear()
    const month = currentDate.getMonth()
    const firstDay = new Date(year, month, 1)
    const lastDay = new Date(year, month + 1, 0)
    const firstWeekday = firstDay.getDay()
    const days = []
    
    const prevLastDate = new Date(year, month, 0).getDate()
    for (let i = firstWeekday - 1; i >= 0; i--) {
      const d = new Date(year, month - 1, prevLastDate - i)
      days.push({ day: d.getDate(), date: d, isCurrentMonth: false, isToday: isSameDay(d, new Date()) })
    }
    
    for (let d = 1; d <= lastDay.getDate(); d++) {
      const dateObj = new Date(year, month, d)
      days.push({ day: d, date: dateObj, isCurrentMonth: true, isToday: isSameDay(dateObj, new Date()) })
    }
    
    const rem = 42 - days.length
    for (let d = 1; d <= rem; d++) {
      const dateObj = new Date(year, month + 1, d)
      days.push({ day: d, date: dateObj, isCurrentMonth: false, isToday: isSameDay(dateObj, new Date()) })
    }
    
    return days
})

const folgasUsadas = computed(() => isKioskMode.value ? tvFolgas.value : props.folgas)
const folgasHoje = computed(() => folgasUsadas.value.filter(f => f.date === new Date().toISOString().split('T')[0] && f.status === 'approved'))
const folgasPendentes = computed(() => folgasUsadas.value.filter(f => f.status === 'pending'))

const folgasEstaSemana = computed(() => {
    const hoje = new Date()
    const inicioSemana = new Date(hoje)
    inicioSemana.setDate(hoje.getDate() - hoje.getDay())
    const fimSemana = new Date(inicioSemana)
    fimSemana.setDate(inicioSemana.getDate() + 6)
    
    return folgasUsadas.value.filter(f => {
      const dataFolga = new Date(f.date)
      return dataFolga >= inicioSemana && dataFolga <= fimSemana && f.status === 'approved'
    })
})

// MÉTODOS E FUNÇÕES AUXILIARES
const isSameDay = (a, b) => a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()

const getFolgasForDay = (date) => {
  if (!date) return []; 
  const dateStr = date.toISOString().split('T')[0]
  return folgasUsadas.value.filter(f => f.date === dateStr)
}
  
const getPlantoesForDay = (date) => {
  if (!date) return [];
  const plantoes = isKioskMode.value ? tvPlantoes.value : props.plantoes;
  if (!plantoes) return [];
  const dateStr = date.toISOString().split('T')[0]
  return plantoes.filter(p => p.date === dateStr && p.status === 'approved')
}

// 2. FUNÇÃO RE-ADICIONADA (getOnCallDutiesForDay)
// Esta função é um sinônimo de getPlantoesForDay, para garantir que não quebre se for chamada em algum lugar.
const getOnCallDutiesForDay = (date) => {
    return getPlantoesForDay(date);
}

const getOnCallDutyMembers = (duty) => {
  const members = []
  if (duty.user_name) members.push({ user_name: duty.user_name, role: 'primary' })
  if (duty.members) {
    duty.members.forEach(member => {
      if (!duty.user_name || member.user_name !== duty.user_name) {
        members.push({ user_name: member.user_name, role: member.role || 'secondary' })
      }
    })
  }
  return members
}
  
const getOnCallSwapRequestsForDay = (date) => {
  const dateStr = date.toISOString().split('T')[0]
  return onCallSwapRequests.value.filter(swap => swap.oncall_duty?.date === dateStr && swap.status === 'pending')
}
  
const getTotalItemsForDay = (date) => {
  return getFolgasForDay(date).length + getOnCallDutiesForDay(date).length + getOnCallSwapRequestsForDay(date).length
}

// Funções de Estilo (getDayClasses, etc.)
const getDayClasses = (day) => {
    if (!day.date) return 'bg-gray-50 dark:bg-gray-800/50';
    const classes = [];
    const dateObj = new Date(day.date);
    const isSaturday = dateObj.getDay() === 6;
    if (day.isCurrentMonth) classes.push('bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700');
    else classes.push('bg-gray-50 dark:bg-gray-700/50 border-gray-100 dark:border-gray-600/50');
    if (day.isToday) classes.push('ring-2 ring-blue-500 dark:ring-blue-400');
    const plantoesDay = getPlantoesForDay(day.date);
    const folgasDay = getFolgasForDay(day.date);
    if (isSaturday && plantoesDay.length > 0) {
      classes.push('!bg-red-50 dark:!bg-red-900/30 border-red-200 dark:border-red-700');
      return classes.join(' ');
    }
    if (folgasDay.some(f => f.status === 'approved')) {
      classes.push('!bg-green-50 dark:!bg-green-900/30 border-green-200 dark:border-green-700');
      return classes.join(' ');
    }
    if (folgasDay.some(f => f.status === 'pending')) {
      classes.push('!bg-yellow-50 dark:!bg-yellow-900/30 border-yellow-200 dark:border-yellow-700');
      return classes.join(' ');
    }
    return classes.join(' ');
}

// Funções de estilo para modo TV
const getTVDayClasses = (day) => {
  if (!day.date) return 'bg-gray-800/50 border-gray-700';
  
  const classes = [];
  const dateObj = new Date(day.date);
  const isSaturday = dateObj.getDay() === 6;
  const isToday = isSameDay(dateObj, new Date());
  
  // Base classes
  if (day.isCurrentMonth) {
    classes.push('bg-white/10 border-white/20');
  } else {
    classes.push('bg-gray-800/30 border-gray-700/50');
  }
  
  // Saturday highlighting
  if (isSaturday) {
    classes.push('border-blue-400/50 bg-blue-500/20');
  }
  
  // Today highlighting
  if (isToday) {
    classes.push('border-yellow-400/70 bg-yellow-500/30');
  }
  
  return classes.join(' ');
}

const getTVFolgaStatusClass = (status) => {
  const baseClasses = 'text-sm px-3 py-2 rounded-lg font-bold border';
  
  switch (status) {
    case 'approved':
      return `${baseClasses} bg-green-500/40 border-green-400/60 text-green-100`;
    case 'pending':
      return `${baseClasses} bg-yellow-500/40 border-yellow-400/60 text-yellow-100`;
    case 'rejected':
      return `${baseClasses} bg-red-500/40 border-red-400/60 text-red-100`;
    default:
      return `${baseClasses} bg-gray-500/30 border-gray-400/50 text-gray-200`;
  }
}

// MÉTODOS DE INTERAÇÃO
const prevMonth = () => {
  if (isKioskMode.value) {
    if (!tvCurrentDate.value) return
    const d = new Date(tvCurrentDate.value)
    d.setMonth(d.getMonth() - 1)
    tvCurrentDate.value = d
    loadTVData()
  } else {
    if (!props.currentDate) return
    const d = new Date(props.currentDate)
    d.setMonth(d.getMonth() - 1)
    emit('update:currentDate', d)
  }
}

const nextMonth = () => {
  if (isKioskMode.value) {
    if (!tvCurrentDate.value) return
    const d = new Date(tvCurrentDate.value)
    d.setMonth(d.getMonth() + 1)
    tvCurrentDate.value = d
    loadTVData()
  } else {
    if (!props.currentDate) return
    const d = new Date(props.currentDate)
    d.setMonth(d.getMonth() + 1)
    emit('update:currentDate', d)
  }
}

const showDayDetails = (day) => {
  selectedDay.value = day
  selectedDayFolgas.value = getFolgasForDay(day.date)
  selectedDayPlantoes.value = getPlantoesForDay(day.date)
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
  selectedDay.value = null
  selectedDayFolgas.value = []
  selectedDayPlantoes.value = []
}

const refreshData = () => {
  if (isKioskMode.value) {
    loadTVData()
  } else {
    emit('refresh')
  }
  lastUpdate.value = new Date()
}

// Função para carregar dados no modo TV
const loadTVData = async () => {
  if (!isKioskMode.value) return
  
  try {
    isLoading.value = true
    console.log('📺 Carregando dados para modo TV:', tvCurrentDate.value)
    
    const year = tvCurrentDate.value.getFullYear()
    const month = tvCurrentDate.value.getMonth() + 1
    
    // Importar apiClient dinamicamente
    const { default: apiClient } = await import('@/services/authService')
    
    // Carregar folgas e plantões para o mês atual
    const [requestsResponse, dutiesResponse] = await Promise.all([
      apiClient.get('/api/v1/daysoff/timeoff/requests/', { 
        params: { year, month, exclude_auto_generated: true } 
      }),
      apiClient.get('/api/v1/daysoff/oncall/duties/', { 
        params: { year, month } 
      })
    ])
    
    tvFolgas.value = requestsResponse.data.results.map(req => ({
      id: req.id,
      user_name: req.user_name || 'Usuário',
      date: req.date,
      reason: req.reason,
      status: req.status
    }))
    
    tvPlantoes.value = dutiesResponse.data.results || dutiesResponse.data || []
    
    console.log('✅ Dados carregados para modo TV:', {
      folgas: tvFolgas.value.length,
      plantoes: tvPlantoes.value.length
    })
    
  } catch (error) {
    console.error('❌ Erro ao carregar dados do modo TV:', error)
  } finally {
    isLoading.value = false
  }
}
  
const abrirModoTV = () => {
  window.open('/calendario-folgas?kiosk=1', '_blank')
}

// 3. FUNÇÕES DE TIMER RE-ADICIONADAS
const startAutoRefresh = () => {
  autoRefreshTimer = setInterval(() => {
    refreshData()
  }, 300000)
}

const stopAutoRefresh = () => {
  if (autoRefreshTimer) {
    clearInterval(autoRefreshTimer)
    autoRefreshTimer = null
  }
}

const getMsUntilMidnight = () => {
  const now = new Date()
  const tomorrow = new Date(now)
  tomorrow.setDate(now.getDate() + 1)
  tomorrow.setHours(0, 0, 0, 0)
  return tomorrow.getTime() - now.getTime()
}

const startDailyUpdate = () => {
  if (!isKioskMode.value) return
  
  // Limpar timers existentes
  stopDailyUpdate()
  
  const msUntilMidnight = getMsUntilMidnight()
  
  // Configurar timer para meia-noite
  dailyUpdateTimer = setTimeout(() => {
    console.log('🔄 Atualização automática diária às 00h - Modo TV')
    refreshData()
    lastUpdate.value = new Date()
    
    // Configurar atualização diária recorrente
    dailyUpdateTimer = setInterval(() => {
      console.log('🔄 Atualização automática diária recorrente - Modo TV')
      refreshData()
      lastUpdate.value = new Date()
    }, 24 * 60 * 60 * 1000) // 24 horas
  }, msUntilMidnight)
  
  console.log(`⏰ Próxima atualização automática em ${Math.round(msUntilMidnight / 1000 / 60)} minutos`)
}

const stopDailyUpdate = () => {
  if (dailyUpdateTimer) {
    clearTimeout(dailyUpdateTimer)
    clearInterval(dailyUpdateTimer)
    dailyUpdateTimer = null
    console.log('⏹️ Atualização automática diária parada')
  }
}

// CICLO DE VIDA
onMounted(() => {
  console.log('🚀 Calendário montado - Modo TV:', isKioskMode.value)
  
  if (isKioskMode.value) {
    // No modo TV, carregar dados diretamente
    loadTVData()
    startDailyUpdate()
  } else {
    // No modo normal, usar o sistema de refresh
    refreshData()
  }
  
  startAutoRefresh()
})

onUnmounted(() => {
  console.log('🛑 Calendário desmontado - Parando timers')
  stopAutoRefresh()
  stopDailyUpdate()
})

watch(() => route.query.kiosk, (val) => {
  const newKioskMode = val === '1'
  console.log('🔄 Modo TV alterado:', newKioskMode)
  
  isKioskMode.value = newKioskMode
  
  if (newKioskMode) {
    console.log('📺 Entrando no modo TV - Carregando dados e iniciando atualização diária')
    tvCurrentDate.value = new Date() // Reset para data atual
    loadTVData()
    startDailyUpdate()
  } else {
    console.log('🖥️ Saindo do modo TV - Parando atualização diária')
    stopDailyUpdate()
  }
})
  

  </script>
  
  
